export function floatingPointMultiplication(
  x: string | number,
  y: string | number,
) {
  const num = typeof x === 'string' ? parseFloat(x) : x;
  const numTwo = typeof y === 'string' ? parseFloat(y) : y;
  const xInt = Math.round(num * 100);
  const yInt = Math.round(numTwo * 100);
  const totalInt = xInt * yInt;

  return (Math.round(totalInt) / 10000).toFixed(2);
}

export function floatingPointSubtraction(
  x: string | number,
  y: string | number,
) {
  const num = typeof x === 'string' ? parseFloat(x) : x;
  const numTwo = typeof y === 'string' ? parseFloat(y) : y;
  const xInt = Math.round(num * 100);
  const yInt = Math.round(numTwo * 100);
  const totalInt = xInt - yInt;
  return Math.round(totalInt) / 100;
}
